import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { UserRoles } from '../enums/roles-enum';

@Injectable({
  providedIn: 'root'
})
export class OperatorGuard implements CanActivate, CanActivateChild {
  constructor(private cognitoService: CognitoService, private router: Router) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return from(this.cognitoService.getUser()).pipe(
      map((userInfo: any) => {
        if (!userInfo || !userInfo.attributes) {
          return this.router.createUrlTree(['/unauthorized']);
        }

        const userGroup = userInfo.attributes['custom:user-group'];

        if (userGroup === UserRoles.aguacate_operator) {
          return true;
        }

        return this.router.createUrlTree(['/unauthorized']);
      }),
      catchError(() => {
        return of(this.router.createUrlTree(['/unauthorized']));
      })
    );
  }
}
